import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import Loader from '../components/theme/Loader';
import RealTimeMap from '../components/realtime/RealTimeMap';

const RealTimePage = () => {
    const { isLoaded, isSignedIn } = useAuth();

    if (!isLoaded) return <Loader />;
    if (!isSignedIn) return <Navigate to="/login" replace={true} />;

    return <RealTimeMap />;
};

export default RealTimePage;
